
<div :class="jel_getClassObject(content)">
  <div class="container p-0">
    <div
      v-if="isSpinnerVisible"
      id="spinner"
      class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
    >
      <b-spinner :label="$t('chargement')"></b-spinner>
    </div>
    <div class="row">
      <div class="col text-left">
        <!-- Affichage des erreurs systèmes -->
        <div v-if="isErreurServeur">
          <MessageMel
            v-show="contentMessageMel.message"
            :content="contentMessageMel.message"
            class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
          ></MessageMel>
        </div>
        <!-- Aucune erreur système (cas normal)  -->
        <div v-else-if="messages.length > 0">
          <!-- Affichage de la liste des messages -->
          <div
            v-for="message in messages"
            :key="message.id"
            class="message row px-1"
            @click="openModal(message)"
          >
            <template v-if="messagesBienJouer[message.messageCode]">
              <div class="col-2 ml-0 px-0">
                <span v-if="message.readDate === null" class="enveloppe">
                  <svg-icon
                    icon-name="ic-enveloppe"
                    color="$couleur-primaire"
                    className="iconeEnveloppe"
                  ></svg-icon>
                </span>
              </div>
              <div class="col-10 ml-0 px-0">
                <span v-if="message.readDate === null">
                  <strong>
                    {{ messagesBienJouer[message.messageCode].msgTitre }}
                  </strong>
                </span>
                <span v-else>
                  {{ messagesBienJouer[message.messageCode].msgTitre }}
                </span>
                <br />
                <span><i>{{ message.createDate.slice(0, message.createDate.indexOf(' ')) }}</i></span>
              </div>
            </template>
          </div>

          <!-- Bouton "Charger plus" centré -->
          <div v-if="hasMoreMessages" class="row px-1">
            <div class="load-more col-12 ml-0 py-1 px-0">
              <b-link class="lienSecondaire" @click="fetchMessages">{{
                content.libBtnAfficherPlus
              }}</b-link>
            </div>
          </div>

          <!-- Composant modal affiché lors du clic sur un message -->
          <MessageModal
            v-if="showModal"
            :message="selectedMessage"
            :messagesBienJouer="messagesBienJouer"
            @close="closeModal"
            @delete="deleteMessage"
          />
        </div>
        <div v-else>
          <div class="row px-1">
            <div class="col-12 ml-0 py-1 px-0">
              {{ $t('notificationsBienJouer.aucuneNotification') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
